export default "__VITE_ASSET__Bsm3wL7o__"